export const STORAGE_VARIABLE = {
  token: 'devugo_prod_token',
  deleteID: 'devugo_prod_deleteID',
};
